import React from 'react'
import PopUpForTest from '../Components/PopUpForTest/PopUpForTest'

const PopUpForTestView = () => {
  return (
    <div>
        <PopUpForTest />
        </div>
  )
}

export default PopUpForTestView